<mat-toolbar class="subtitulo">Escolha o aluno para o familiar</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <form #formConsultar="ngForm">

        <div class="painel-consultar">
    
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-icon>search</mat-icon>
                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    
                    <div ngModelGroup="comboBeneficiario" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="40px">
                        <combo-pesquisavel #comboBeneficiario 
                                           nome="beneficiario" 
                                           [itens]="comboAluno" 
                                           itemDescricao="descricaoCombo"
                                           itemId="id"
                                           [showDisplayId]="false" 
                                           [obrigatorio]="false"
                                           placeholder="Informe o nome do beneficiário"
                                           [(valor)]="aluno"
                                           (valorChange)="onValorChange($event)">
                        </combo-pesquisavel>
                    </div>
    
   
                    <button mat-raised-button
                            color="primary"
                            (click)="limparSelecao()"
                            placeholder="Limpar seleção"
                            style="margin-top: 15px !important; height: 33px;">
                        LIMPAR
                    </button>
                </div>
            </div>
    
            <div *ngIf="alunoSelecionado && alunoSelecionado.id">
                <dados-aluno [aluno]="alunoSelecionado"></dados-aluno>
            </div>
    
        </div>
    </form>
</div>

<!-- ESCOLHA DO FAMILIA DO ALUNO -->
<div *ngIf="alunoSelecionado && alunoSelecionado.id" style="padding: 10px;">

    <familiares [aluno]="alunoSelecionado"></familiares>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-right: 40px">
        <div>
            <button matTooltip="Adicionar novo familiar do aluno" mat-fab color="primary" (click)="goCadastrar()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>



<div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    <button mat-raised-button
            fxFlex="20%"
            color="primary"
            (click)="cancelar()">
        Cancelar
    </button>
</div>